const mutations = {
  'SET_BUSINESS_GROUP' (state, value) {
    state.businessGroup = value
  },
  'SET_BUSINESS_GROUPS' (state, value) {
    state.businessGroups = value
  }
}

export default mutations